import moment from "moment";
import { Icon } from "@iconify/react";
import { IconButton } from "@mui/material";
import "./Preview.css";
import renderButtons from "../../../Helper/renderButtons";
import renderWAPreviewBody from "../../../Helper/renderWAPreviewBody";
import documentIconDefault from "../../../Images/DocumentIconDefault.svg";
import documentIconDOC from "../../../Images/DocumentIconDOC.svg";
import documentIconMP3 from "../../../Images/DocumentIconMP3.svg";
import documentIconPDF from "../../../Images/DocumentIconPDF.svg";
import documentIconPPT from "../../../Images/DocumentIconPPT.svg";
import documentIconRAR from "../../../Images/DocumentIconRAR.svg";
import documentIconTXT from "../../../Images/DocumentIconTXT.svg";
import documentIconXLS from "../../../Images/DocumentIconXLS.svg";
import documentIconZIP from "../../../Images/DocumentIconZIP.svg";

const Preview = ({ componentsValues, isCallPermission, parameterFormat }) => {
  // Bytes formatter for attachment size
  const formatBytes = (bytes) => {
    const sizeSuffixes = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    return (
      (!bytes && "0 Bytes") ||
      (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizeSuffixes[i]
    );
  };

  const renderAttachmentIcon = () => {
    let icon;

    switch (componentsValues.header.attachment.type) {
      case "pdf":
        icon = documentIconPDF;
        break;

      case "txt":
        icon = documentIconTXT;
        break;

      case "xls":
      case "xlsx":
        icon = documentIconXLS;
        break;

      case "ppt":
      case "pptx":
        icon = documentIconPPT;
        break;

      case "doc":
      case "docx":
        icon = documentIconDOC;
        break;

      case "rar":
        icon = documentIconRAR;
        break;

      case "zip":
        icon = documentIconZIP;
        break;

      case "mp3":
      case "mpga":
        icon = documentIconMP3;
        break;

      default:
        icon = documentIconDefault;
        break;
    }

    return <img alt="" height="30" src={icon} />;
  };

  function renderWAPreviewHeader() {
    if (parameterFormat === "positional") {
      return componentsValues.header.headerText?.replace(
        "{{1}}",
        componentsValues.header.headerVariable
          ? componentsValues.header.headerVariable
          : "{{1}}"
      );
    } else {
      return componentsValues.header.headerText?.replace(
        /\{\{[^}]+\}\}/g,
        componentsValues.header.headerVariable
          ? componentsValues.header.headerVariable
          : `{{${componentsValues.header.headerVariableName}}}`
      );
    }
  }

  return (
    <section className="preview">
      <header>Preview</header>

      <div className="preview-screen">
        <div
          className={`preview-message ${
            componentsValues.button.length ? "has-buttons" : ""
          }`}
        >
          {componentsValues.header.attachment.file ? (
            componentsValues.header.attachment.type === "image/jpeg" ||
            componentsValues.header.attachment.type === "image/jpg" ||
            componentsValues.header.attachment.type === "image/png" ? (
              <img
                alt=""
                className="header-image"
                src={componentsValues.header.attachment.file}
              />
            ) : componentsValues.header.attachment.type === "video/mp4" ? (
              <video>
                <source
                  src={componentsValues.header.attachment.file}
                  type={componentsValues.header.attachment.type}
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <div className="header-attachment">
                <div className="attachment-left">
                  {renderAttachmentIcon()}

                  <div className="attachment-info">
                    <p className="attachment-name">
                      {componentsValues.header.attachment.name}
                    </p>

                    <p className="attachment-details">
                      {componentsValues.header.attachment.type?.toUpperCase()} ·{" "}
                      {formatBytes(componentsValues.header.attachment.size)}
                    </p>
                  </div>
                </div>

                <IconButton>
                  <Icon height="30" icon="ic:sharp-file-download" />
                </IconButton>
              </div>
            )
          ) : (
            ""
          )}

          <p className="header-text">
            {/* {componentsValues.header.headerText?.replace(
              "{{1}}",
              componentsValues.header.headerVariable
                ? componentsValues.header.headerVariable
                : "{{1}}"
            )} */}

            {renderWAPreviewHeader()}
          </p>

          <div
            className="body-text"
            dangerouslySetInnerHTML={{
              __html: renderWAPreviewBody(
                componentsValues,
                componentsValues.bodyText,
                false,
                parameterFormat
              ),
            }}
          />

          <p className="footer-text">{componentsValues.footerText}</p>
          <p className="time">{moment().format("HH:mm")}</p>

          <div className="button-container">
            {renderButtons(componentsValues.button)}
          </div>
        </div>

        {isCallPermission && (
          <div className="preview-message call-permission">
            <div className="text-container">
              <div>
                <div className="call-icon">
                  <Icon height="24" icon="material-symbols:call" />
                </div>

                <p className="body-text">Can [Business Name] call you?</p>
              </div>

              <p className="time">{moment().format("HH:mm")}</p>
            </div>

            <div className="preference">
              <p>Choose preference</p>
              <Icon height="18" icon="mingcute:down-fill" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Preview;
